<template>
    <div
        class="check"
        :class="{
            defaultCheck: calcClass === 'defaultCheck',
            greenCheck: calcClass === 'greenCheck',
            redCheck: calcClass === 'redCheck',
        }"
        @click="clickHandler"
    ></div>
</template>

<script>
export default {
    name: 'CheckHardCompetence',
    props: {
        green: {
            type: Boolean,
            default: false,
        },
        checked: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        calcClass() {
            if (this.checked === null) {
                return 'defaultCheck';
            } else if (this.checked && this.green) {
                return 'greenCheck';
            } else if (this.checked && !this.green) {
                return 'redCheck';
            } else return 'defaultCheck';
        },
    },
    methods: {
        clickHandler() {
            this.$emit('setAcknowledge');
        },
    },
};
</script>

<style lang="scss" scoped>
    .check{
        width: 22px;
        height: 22px;
        cursor: pointer;
    }
    .defaultCheck{
        background: #F8F8F8;
        border: 1px solid #98A0A9;
        box-sizing: border-box;
        border-radius: 50%;
    }
    .redCheck{
        border-radius: 50%;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        background-image: url("../../../../../../assets/images/account-track/icon/competences/apply-false.svg");
    }
    .greenCheck{
        border-radius: 50%;
        background-image: url("../../../../../../assets/images/account-track/icon/competences/apply-true.svg");
    }
</style>